<script lang="ts" setup></script>

<template>
  <svg fill="none" height="21" viewBox="0 0 20 21" width="20" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.496 12.79H12.314V20.162H7.298V12.79H0.116V8.154H7.298V0.782H12.314V8.154H19.496V12.79Z"
      fill="#F40000"
    />
  </svg>
</template>

<style lang="sass" scoped></style>
